<template>
    <fragment>
        <template v-for="(item) in menuData" >
                <el-submenu
                    v-if="item.children && item.children.length > 0"
                    :key="item+item.path" :index="item.path" >
                    <template slot="title">
                        <!-- <i :class="item.icon"></i> -->
                        <span style="margin-left:5%;">{{ item.name }}</span>
                    </template>
                    <menuc :menuData="item.children"></menuc>
                </el-submenu>
                <el-menu-item v-else :key="item.id+'.'" :index="item.path" >
                    <!-- <i :class="item.icon"></i> -->
                    <span style="margin-left:5%;">{{ item.name }}</span>
                </el-menu-item>
        </template>
  </fragment>
</template>
<script>
    export default{
        name: "menuc",//必须要 递归组件的关键，并且要与引入组件的变量名称一致

        props: ["menuData"],

      
    }
</script>
<style lang="less" scoped>

</style>